import { SHOW_SPINNER, HIDE_SPINNER, HIDE_NOTIFICATION } from '../types';

export const showSpinner = (text = '') =>  dispatch => {
  dispatch({ type: HIDE_NOTIFICATION });
  dispatch({
    type: SHOW_SPINNER,
    payload: text
  });
}

export const hideSpinner = () => dispatch => {
  dispatch({ type: HIDE_SPINNER }) 
}